import React, { useState, useContext } from "react";
import axios from "axios";
import styled from "styled-components";
import { NotificationManager } from "react-notifications";
import moment from "moment";
import DateInput from "components/Input/DateInput.js";
import CustomSelect from "components/Input/CustomSelect.js";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import { mandates } from "variables/markets";
import { memberorderStatusDataAdmin } from "variables/lists/markets";
import { putMarketMembershipOrder } from "services/ConfigServices";
import { MarketsContext } from "context/MarketsContext";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "65ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "65ch",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;

function EditServiceOrderStatusDialog(props) {
  const { closeModal, refetch, serviceorder, market } = props;
  const [status, setStatus] = useState(serviceorder.parameters.status);
  const [buttonDisabled, setButtonDisabled] = useState(false);

  const handleSubmit = async (event) => {
    updateMarketMembershipOrder(event);
  };

  const handleStatusChange = (event) => { setStatus(event.target.value); };

  const updateMarketMembershipOrder = async (event) => {
    await axios
      .put(
        putMarketMembershipOrder(serviceorder.id, market.id),
        {
          serviceorderparameters:
          {
            ...serviceorder.parameters,
            status,
          }
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Statut modifié");
        } else setNotification("error", "Une erreur est survenue");
        closeModal();
        refetch();
      })
      .catch((error) => {
        console.log(error);
        setNotification("error", "Une erreur est survenue");
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const classes = useStyles();

  return (
    <>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>

            <div>
              <CustomSelect
                inputTitle={mandates.status}
                selectValue={status}
                handleSelectValueChange={handleStatusChange}
                data={memberorderStatusDataAdmin}
              />
            </div>
            <Button
              disabled={buttonDisabled}
              className={
                buttonDisabled
                  ? classes.submitButtonDisabled
                  : classes.submitButton
              }
              onClick={() => {
                handleSubmit();
              }}
            >
              Modifier
            </Button>
          </GridItem>
        </GridContainer>
      </form>
    </>
  );
}

export default EditServiceOrderStatusDialog;
